const ErrorPage = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>Payment Failure!</h1>
            <p>There was an error authorizing your payment</p>
        </div>
    );
};

export default ErrorPage;
